module.exports = __webpack_public_path__ + "img/camera.c90ede10.png";